<template lang="pug">
div.expande-horizontal.wrap(style="background: #f2f2f2;")
  checkout-header
  div.expande-horizontal.centraliza.wrap.pa-1
    v-flex(xs12 md10)
      div.expande-horizontal.wrap
        v-flex(xs12 md4).pa-3
          checkout-items
        v-flex(xs12 md8).pa-3
          div(style="background: #fff;border-radius: 6px;").cool-shaddow.expande-horizontal.wrap.pa-6
            checkout-informations
            //- checkout-payment-method
            checkout-submit
  modal-order-status
</template>

<script>
import CheckoutHeader from "./CheckoutHeader.vue";
import CheckoutItems from "./CheckoutItems/index.vue";
import CheckoutInformations from "./CheckoutInformations/index.vue";
import CheckoutPaymentMethod from "./CheckoutPaymentMethod/index.vue";
import CheckoutSubmit from "./CheckoutSubmit/index.vue";
import ModalOrderStatus from "./ModalOrderStatus/index.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["plan_slug"],
  components: {
    CheckoutHeader,
    CheckoutItems,
    CheckoutInformations,
    CheckoutPaymentMethod,
    CheckoutSubmit,
    ModalOrderStatus
  },
  computed: {
    ...mapGetters(["get_checkout"])
  },
  methods: {
    ...mapActions(["view_plan", "check_transaction_payment"])
  },
  mounted() {
    if (this.plan_slug) {
      this.view_plan({
        plan_slug: this.plan_slug,
        trial: true
      });
    }
    if (this.$route.query.t_id) {
      this.check_transaction_payment(this.$route.query.t_id);
    }
  }
};
</script>
